import { STUDIO_LOADER } from '../keys';
import { GET_USER_STUDIO_WALL, UPDATE_STATUS_KEY } from '../keys'
const initialState = { studioWall: [] }
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case GET_USER_STUDIO_WALL: {
            return { ...state, studioWall: action.payload }
        }
        case STUDIO_LOADER: {
            return { ...state, studioLoader: action.payload ? false : true }
        }
        case UPDATE_STATUS_KEY: {
            let { studioWall } = state;
            studioWall.is_studio_enabled = action.payload;
            return { ...state, studioWall }
        }
        default:
            return { ...state }
    }

}